var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSetColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.84375 0.8125H4.65625C5.41797 0.8125 6.0625 1.45703 6.0625 2.21875V6.90625C6.0625 7.69727 5.41797 8.3125 4.65625 8.3125H1.84375C1.05273 8.3125 0.4375 7.69727 0.4375 6.90625V2.21875C0.4375 1.45703 1.05273 0.8125 1.84375 0.8125ZM9.34375 6.4375H12.1562C12.918 6.4375 13.5625 7.08203 13.5625 7.84375V12.5312C13.5625 13.3223 12.918 13.9375 12.1562 13.9375H9.34375C8.55273 13.9375 7.9375 13.3223 7.9375 12.5312V7.84375C7.9375 7.08203 8.55273 6.4375 9.34375 6.4375ZM0.4375 11.5938C0.4375 10.832 1.05273 10.1875 1.84375 10.1875H4.65625C5.41797 10.1875 6.0625 10.832 6.0625 11.5938V12.5312C6.0625 13.3223 5.41797 13.9375 4.65625 13.9375H1.84375C1.05273 13.9375 0.4375 13.3223 0.4375 12.5312V11.5938ZM9.34375 0.8125H12.1562C12.918 0.8125 13.5625 1.45703 13.5625 2.21875V3.15625C13.5625 3.94727 12.918 4.5625 12.1562 4.5625H9.34375C8.55273 4.5625 7.9375 3.94727 7.9375 3.15625V2.21875C7.9375 1.45703 8.55273 0.8125 9.34375 0.8125Z",
    fill: "#494968"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSetColumn);
export default __webpack_public_path__ + "static/media/icon_set_column.9ff282a8d99149ffd732088fda3f266c.svg";
export { ForwardRef as ReactComponent };